import { render, staticRenderFns } from "./DeptSelecter.vue?vue&type=template&id=ebdf44e8&scoped=true"
import script from "./DeptSelecter.vue?vue&type=script&lang=js"
export * from "./DeptSelecter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdf44e8",
  null
  
)

export default component.exports